export const serviceItems = [
  { value: 3, label: 'お片付けサービス' },
  { value: 2, label: '整理収納サービス' },
  { value: 1, label: '掃除代行サービス' },
  { value: 4, label: '料理代行サービス' },
];
export const serviceNowItems = [{ value: 1, label: '掃除代行サービス' }];
